import { render, staticRenderFns } from "./aboutMM.vue?vue&type=template&id=315db7cb&scoped=true"
import script from "./aboutMM.vue?vue&type=script&lang=js"
export * from "./aboutMM.vue?vue&type=script&lang=js"
import style0 from "./aboutMM.vue?vue&type=style&index=0&id=315db7cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315db7cb",
  null
  
)

export default component.exports